<template>
  <div>
    <el-form size="small" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm"
             :disabled="ruleFormDisabled">
      <el-form-item label="星级评价" prop="score">
        <el-rate
          show-text
          v-model="ruleForm.score"
          :colors="colors"
          :texts="texts">
        </el-rate>
      </el-form-item>
      <el-form-item label="评价内容" prop="content">
        <el-input type="textarea" v-model="ruleForm.content"></el-input>
      </el-form-item>
      <el-form-item label="匿名评价" prop="isAnonymous">
        <el-switch
          v-model="ruleForm.isAnonymous">
        </el-switch>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
        <el-button @click="resetForm('ruleForm')">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  export default {
    name: "evaluationCom",
    props: ['goodsData'],
    data() {
      return {
        ruleFormDisabled: false,
        ruleForm: {
          content: '',
          score: 5,
          isAnonymous: false
        },
        colors: ['#99A9BF', '#F7BA2A', '#FF9900'],
        texts: ['1分', '2分', '3分', '4分', '5分'],
        rules: {
          score: [
            {required: true, message: '请选择星级', trigger: ['blur', 'change']}
          ],
          content: [
            {required: true, message: '请输入评价内容', trigger: 'blur'}
          ],
        }
      }
    },
    // 创建完成
    created() {
      if (this.goodsData.commentStatus === 1) {
        this.getCommentFn();
      }
    },
    // import引入的组件需要注入到对象中才能使用
    components: {},
    // 方法集合
    methods: {
      async getCommentFn() {
        try {
          let res = await this.$http.get(this.$const.personalCenter.getComment + '/' + this.goodsData.orderItemId);
          if (res && res.data && res.code === 200) {
            let data = res.data;
            this.ruleFormDisabled = true;
            this.ruleForm = data;
          }
        } catch (e) {
          // console.log(e);
        }
      },
      submitForm(formName) {
        this.$refs[formName].validate(async (valid) => {
          if (valid) {
            // type 评论类型：1：商品评论:2：用户评论
            // goodsId 商品id
            // content 评论内容
            // score 评分：type=1时有效
            // evaluate 评价：type=1时有效；1：好评；2：中评；3：差评
            // is_anonymous 是否匿名（1：是；0：否）
            let params = {
              type: 1,
              goodsId: this.goodsData.goodId,
              orderItemId: this.goodsData.orderItemId,
              content: this.ruleForm.content,
              score: this.ruleForm.score,
              evaluate: this.ruleForm.score <= 2 ? "1" : this.ruleForm.score <= 4 ? "2" : "3",
              isAnonymous: this.ruleForm.isAnonymous,
            };
            let res = await this.$http.post(this.$const.personalCenter.commentAdd, params);
            if (res && res.code === 200 && res.data) {
              this.$message.success(this.$PubText.successCom);
              this.$emit('evaluationFn', 1);
            }
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
        this.$emit('evaluationFn', 2);
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
